import config from "../config";

function DonatePage() {
  return (
    <main className="bg-white py-16">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Page Title */}
        <h1 
          className="text-5xl font-bold text-center mb-8 text-black" 
          style={{ fontFamily: 'Poppins, sans-serif' }}
        >
          Support {config.candidateName}'s Campaign
        </h1>
        
        <div className="text-center mb-12">
          <p className="text-xl text-black max-w-3xl mx-auto">
            {config.donations.description}
          </p>
        </div>

        {/* Donation Banner with Grayed Background Image */}
        <div className="relative py-16 px-8 rounded-lg shadow-md text-center mb-12">
          {/* Background image with overlay */}
          <div 
            className="absolute inset-0 rounded-lg"
            style={{ 
              backgroundImage: `url(${config.donations.imageUrl})`,
              backgroundSize: "cover",
              backgroundPosition: "left center",
            }}
          >
            {/* Gray overlay */}
            <div className="absolute inset-0 bg-gray-800 opacity-40 rounded-lg"></div>
          </div>
          
          {/* Content positioned over the background */}
          <div className="relative z-10">
            <a 
              href={config.donations.url}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-block bg-white text-black text-2xl font-bold py-4 px-12 rounded-full shadow-lg hover:bg-gray-100 transition"
            >
              DONATE NOW
            </a>
          </div>
        </div>

        {/* Disclaimer */}
        <div className="max-w-3xl mx-auto text-center">
          <p className="text-sm text-gray-700 mb-2">
            <strong>Campaign contributions are not tax-deductible.</strong>
          </p>
        </div>
      </div>
    </main>
  );
}

export default DonatePage;